module.exports = __webpack_public_path__ + "assets/images/project/head/Nana_Matsuoka.jpg?v=d5794b9c";